import { useRef } from "react";
import { UserManager } from "services/util/UserManager";
import useAuthStore from "store/useAuthStore";
import useUserStore, { UserInfoDataType } from "store/useUserStore";

export interface LoginConfig {
  accessToken: string;
  refreshToken: string;
  userId?: string;
}

function useUser() {
  const userManagerRef = useRef(new UserManager());
  const setIsLogin = useAuthStore((store) => store.setIsLogin);
  const userInfoData = useUserStore((store) => store.userInfoData);
  const setUserInfoData = useUserStore((store) => store.setUserInfoData);
  const clearUserInfoData = useUserStore((store) => store.clearUserInfoData);

  const isLogin = (): void => {
    let isLoggedIn = userManagerRef.current.checkLogin();
    setIsLogin(isLoggedIn);
  };

  const getUserInfo = (): UserInfoDataType | null => {
    let userInfo = userManagerRef.current.getUserInfo();
    if (!userInfo) userInfo = userInfoData;
    return userInfo;
  };
  const setUserInfo = (userInfo: UserInfoDataType) => {
    setUserInfoData(userInfo);
    userManagerRef.current.setUserInfo(userInfo);
  };

  const getTokens = (): LoginConfig | null => {
    const userId = userManagerRef.current.getUserId();
    const accessToken = userManagerRef.current.getAccessToken();
    const refreshToken = userManagerRef.current.getRefreshToken();

    if (accessToken && refreshToken && userId)
      return { accessToken, refreshToken, userId };
    else return null;
  };

  const setTokens = ({
    accessToken,
    refreshToken,
    userId,
  }: LoginConfig): void => {
    userId && userManagerRef.current.setUserId(userId);
    userManagerRef.current.setAccessToken(accessToken);
    userManagerRef.current.setRefreshToken(refreshToken);
    setIsLogin(true);
  };

  const clear = () => {
    userManagerRef.current.clear();
    clearUserInfoData();
    setIsLogin(false);
  };

  return {
    isLogin,
    setUserInfo,
    getUserInfo,
    getTokens,
    setTokens,
    clear,
  };
}

export default useUser;
